/*
///// HOW TO USE:

{% render 'load-more' id: 'paginate-previous', paginatePart: paginate.previous, target: targetId, position: 'prepend', label: 'load more' %}

<div id='{{ targetId }}'>  </div>

{% render 'load-more' id: 'paginate-next', paginatePart: paginate.next, target: targetId, position: 'append', label: 'load more' %}

*/

class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.sumbitButton = this.querySelector("[type='submit']") || this.querySelector("button");
    if (!this.sumbitButton) return;
    this.sumbitButton.addEventListener("click", this.onSubmitHandler.bind(this));
  }

  updateUrl(url) {
    window.history.replaceState({}, "", url);
  }

  onSubmitHandler() {
    this.sumbitButton.setAttribute("disabled", "");

    const sectionId = this.dataset.section;
    const baseUrl = this.dataset.url;
    const url = `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(this.dataset.target);
        const source = html.getElementById(this.dataset.target);

        if (source && destination) {
          switch (this.dataset.position) {
            case "prepend":
              source.innerHTML += destination.innerHTML;
              destination.innerHTML = source.innerHTML;
              break;
            case "append":
              destination.innerHTML += source.innerHTML;
              break;
          }
        }

        this.sumbitButton.removeAttribute("disabled");
        this.updateUrl(baseUrl);

        document.querySelectorAll("load-more").forEach((loadmore) => {
          const match = html.querySelector(`load-more#${CSS.escape(loadmore.id)}`);
          if (!match) {
            loadmore.remove();
            return;
          }
          loadmore.setAttribute("data-url", match.dataset.url);
        });

        if (typeof window.restoreCheckoutButton === "function") {
          window.restoreCheckoutButton();
        }
      })
      .catch(() => {
        window.location.href = baseUrl;
      });
  }
}

customElements.define("load-more", LoadMore);

// Restore PLP scroll position to the last clicked
(function setupPLPScrollRestore() {
  const KEY = "plp_last_clicked_product_id";
  const COL_URL = "plp_last_click_to_url";
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    const card = link.closest("[data-product-id]");
    if (!card) return;

    localStorage.setItem(KEY, card.getAttribute("data-product-id"));
    localStorage.setItem(COL_URL, window.location.href);
  });

  window.addEventListener("pageshow", () => {
    const productId = localStorage.getItem(KEY);
    const collectionURL = localStorage.getItem('plp_last_click_to_url');
    console.log(collectionURL, "HEREEEE")
    if (!productId || collectionURL != window.location.href) return;

    const el =
      document.getElementById(`ProductCard-${productId}`) ||
      document.querySelector(`[data-product-id="${CSS.escape(productId)}"]`);

    if (!el) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.scrollIntoView({ block: "center" });
      });
    });
  });
})();

